/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { IconButton, Box, Avatar } from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { useTheme } from "@mui/material/styles";

const SelectedBadge = (props) => {
    
    const theme = useTheme();
    const {
        // onClick,
        color = theme.palette.primary.main
    } = props || {};
    const avatarStyle = {
        bgcolor: color,
        width: 32,
        height: 32,
        boxShadow: theme.shadows[15],
    };
    const buttonStyle = {
        color: "#FFFFFF",
    };

    return (
        <Fragment>
            <Box>
                <Avatar
                    variant="circular"
                    sx={avatarStyle}
                >
                    <IconButton
                        style={buttonStyle}
                        aria-label='selected image'
                        component='span'
                        // onClick={onClick}
                    >
                        <CheckRoundedIcon />
                    </IconButton>
                </Avatar>
            </Box>
        </Fragment>
    );
};

export default SelectedBadge;
